/**
 * 方法导出文件
 */

var exports = require("../support/exports.js");

exports(
		"browser",
		"woxinSupport" ,
		"fdapi"
);




//////////////////
// WEBPACK FOOTER
// ./src/main/javascript/exports/tellhowdm.js
// module id = 0
// module chunks = 0